<template>
    <div class="content-container">
        <!-- Content -->
        <div class="triage-content">

            <div class="container h-auto pb-5">
                <div class="row">
                    <!-- Title -->
                    <div class="col-12 pt-4">
                        <div class="title">
                            <h1 class="mb-3">Enter the appliance model code</h1>
                        </div>
                        <a class="text-sm text-muted" target="_blank" href="https://likewize-files.s3.eu-west-2.amazonaws.com/guides/How_do_I_find_my_appliance_model_code.pdf?">How do I find my appliance model code?</a>
                        <input type="text" name="model_code" id="modelCode" class="form-control text-uppercase" placeholder="Enter the model code" v-model="newApplianceModelCode" @change="updateApplianceModelCode(newApplianceModelCode)"/>
                    </div>
                </div>
            </div>

            <div class="container h-auto pb-0">
                <div class="row">
                    <!-- Title -->
                    <div class="col-12 pt-4">
                        <div class="title">
                            <h1 class="mb-4">What faults are you seeing?</h1>
                        </div>
                    </div>
                </div>
            </div>

            <div class="container">
                <div class="row mb-3" v-for="question in currentTriageAnswers" :key="question.id">
                    <div class="col-12 mb-1">
                        <div class="form-check pl-0">
                            <div class="custom-control custom-checkbox d-flex">
                                <input
                                    type="checkbox"
                                    :id="`question-${question.id}`"
                                    :value="question.fault_present"
                                    class="custom-control-input"
                                    v-model="question.fault_present"
                                >
                                <label :for="`question-${question.id}`" class="custom-control-label mb-0 flex-grow-1">
                                    {{ question.question }}
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="col-12" v-if="question.fault_present">
                        <div class="form-group input-group mb-0">
                            <textarea
                                type="text"
                                class="form-control"
                                rows="2"
                                :name="question.code + '-description'"
                                v-model="question.fault_description"
                                :placeholder="question.fault_present ? 'Enter a description of your fault' : ''"/>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Footer -->
            <footer class="footer mx-auto">
                <div class="container">
                    <router-link :to="{ name: 'deviceModel'}" class="btn btn-outline-secondary back-btn btn-lg"><i class="fa fa-chevron-left text-sm mr-3"></i> Back</router-link>
                    <button @click="saveSelection()" class="btn btn-lg continue-btn icon-right ml-auto" :class="{'disabled': !canContinue}">Next <i class="fa fa-chevron-right ml-3 text-sm"></i></button>
                </div>
            </footer>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
    name: "deviceTriage",

    mounted() {
        this.newApplianceModelCode = this.applianceModelCode;
        this.checkCanBeOnPage();
        for (let i = 0; i < this.triageQuestions.length; i++) {
            this.$set(this.currentTriageAnswers, i, this.triageQuestions[i]);

            for (let i = 0; i < this.triageAnswers.length; i++) {
                if (this.triageAnswers[i].code === this.triageQuestions[i].code) {
                    this.$set(this.currentTriageAnswers, i, this.triageAnswers[i]);
                }
            }
        }
    },

    data() {
        return {
            newApplianceModelCode: null,
            currentTriageAnswers: []
        }
    },

    computed: {
        ...mapGetters([
            "activeModelVersionId",
            "allowsInsuranceOrder",
            "isBookingInStore",
            "makeIsSamsung",
            "modelHasBeenSelected",
            "modelVersions",
            "modelVersionHasBeenSelected",
            "modelVersionIsActive",
            "selectedModel",
            "reference",
            "triageQuestions",
            "triageAnswers",
            "applianceModelCode"
        ]),

        canContinue() {
            if (!this.newApplianceModelCode) {
                return false;
            }
            let questionAnswered = false;
            for (let i = 0; i < this.currentTriageAnswers.length; i++) {
                if (this.currentTriageAnswers[i].fault_present && this.currentTriageAnswers[i].fault_description !== "") {
                    questionAnswered = true;
                }
            }
            return questionAnswered;
        },
    },

    methods: {
        ...mapActions([
            "checkBookingIsComplete",
            "displayToast",
            "updateDevice",
            "setTriageAnswers",
            "updateApplianceModelCode"
        ]),

        /** Check the user can be on the page */
        checkCanBeOnPage() {
            this.checkBookingIsComplete().then(() => {
                if (!this.modelHasBeenSelected) {
                    this.$router.push({name: 'deviceModel'});
                }
            });
        },

        saveSelection() {
            this.setTriageAnswers(this.currentTriageAnswers).then(() => {
                this.updateDevice(true).then(() => {
                    this.$router.push({name: 'basket'});
                }).catch(response => {
                    const error = response.response.data.messages;
                    this.displayToast({text: error, type: 'error'});
                })
            })
        }
    }
};
</script>

<style scoped>

</style>